/* eslint-disable @typescript-eslint/ban-ts-comment */
export type ImageInstance = {
  image: HTMLImageElement;
  aspectRatio: number;
};

/**
 * @description  创建图片并返回Promise
 * @param {string} src    图片地址
 * @param {object} opt merge进image实例属性，如{crossOrigin: ""}，将image的crossOrigin设置为""
 * @returns
 */
const createImage = (src: string, opt?: any): Promise<ImageInstance> => {
  return new Promise((resolve, reject) => {
    const image = new window.Image();
    image.onload = (): void => {
      resolve({
        image,
        aspectRatio: image.width / image.height,
      });
    };
    image.onabort = (e): void => {
      reject(e);
    };
    image.onerror = (e): void => {
      reject(e);
    };
    image.src = src;
    image.crossOrigin = 'Anonymous';
    if (opt) {
      Object.entries(opt).forEach(([key, value]) => {
        // @ts-ignore
        image[key] = value;
      });
    }
  });
};

export default createImage;
